import { CONST } from '@common/constants/const.constant';

export const formatPrice = (price: number, excludeZeroDecimals?: boolean): string => {
    if (!price) {
        return `${CONST.CURRENCY_SYMBOL}${price.toFixed(2)}`;
    }
    const sign = price < 0 ? '-' : '';
    // return `£${price / 100}`;
    const priceValue = Math.abs(price) / 100;

    // Check if price contains any decimals, if not then dont return them
    if(excludeZeroDecimals && priceValue % 1 === 0){
        return `${sign}${CONST.CURRENCY_SYMBOL}${(priceValue).toFixed(0)}`
    }

    return `${sign}${CONST.CURRENCY_SYMBOL}${(priceValue).toFixed(2)}`;
};
